module.exports = __webpack_public_path__ + "static/media/TheVanishingDeepBookCover.e44f2edb.jpg";